const menu = document.querySelector(".header__mainMenu");
const openMenu = document.querySelector(".js-openMenu");
openMenu.addEventListener('click', function() {
    menu.classList.add("_active");
})
const closeMenu = document.querySelector(".js-closeMenu");
closeMenu.addEventListener('click', function() {
    menu.classList.remove("_active");
})

const closeMenuOutside = (event) => {
    if (!menu.contains(event.target) && !openMenu.contains(event.target)) {
        menu.classList.remove("_active");
    }
};

document.addEventListener("click", closeMenuOutside);